import React, { useState } from 'react';
import { Box, List, ListItem, Stack, useMediaQuery, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Circle } from '@mui/icons-material';
import style from './style';

const FaqContainer = ({ InsuranceHeading, InsuranceList }) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const md = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const hasLink = description => {
    const regex = /<a\b[^>]*>/i;
    return regex.test(description);
  };

  return (
    <Box style={{ width: sm || md ? '100%' : '75rem' }} id='faq-section'>
      <Box sx={style(theme).mainHeadingBox}>
        <Stack display='block'>
          <Typography variant='h2' component='h2' sx={style(theme).mainHeading}>
            {InsuranceHeading}
          </Typography>
        </Stack>
      </Box>
      {InsuranceList?.map((list, i) => (
        <Accordion
          disableGutters
          square
          key={i}
          expanded={expanded === `${list.Title}`}
          onChange={handleChange(`${list.Title}`)}
          sx={style(theme).accordMain}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                sx={{
                  color: theme.palette.primary.buttonColor,
                  paddingRight: '4px',
                  fontSize: theme.typography.h3.fontSize,
                }}
              />
            }
            sx={{ ...style(theme).accordSummaryMain, p: sm ? '0px 8px 0px 0px' : '' }}
          >
            <Typography variant='body3Medium' sx={style(theme).accordSummaryTitle}>
              {list?.Title}
            </Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: '0px' }}>
            {list?.ListDescription?.length > 0 && (
              <List sx={{ padding: sm ? '8px 22px 25px 8px' : '8px 33px 25px 25px' }}>
                {list?.ListDescription?.map(description => (
                  <ListItem key={description.id} sx={{ padding: '0px 0px 0px 0px' }}>
                    <Stack direction='row' sx={{ width: '100%' }}>
                      <Circle
                        sx={{
                          height: 6,
                          width: 6,
                          mt: '11px',
                          color: theme.palette.primary.textColor3,
                        }}
                      />
                      {hasLink(description.Description) ? (
                        <Typography
                          variant='body1'
                          color={theme.palette.primary.textColor3}
                          sx={{ pl: 1 }}
                        >
                          {description.Description.substring(
                            0,
                            description.Description.indexOf('<a')
                          )}
                          <Link
                            href={description.Description.match(/href="([^"]+)"/)[1]}
                            target='_blank'
                            rel='noopener noreferrer'
                            sx={{ color: theme.palette.secondary.errorCTA }}
                          >
                            {description.Description.match(/<a[^>]*>([^<]+)<\/a>/)[1]}
                          </Link>
                          {description.Description.substring(
                            description.Description.indexOf('</a>') + 4
                          )}
                        </Typography>
                      ) : (
                        <Typography
                          variant='body1'
                          color={theme.palette.primary.textColor3}
                          sx={{ pl: 1 }}
                        >
                          {description.Description}
                        </Typography>
                      )}
                    </Stack>
                  </ListItem>
                ))}
              </List>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FaqContainer;
